import { Component, OnInit } from '@angular/core';
import {Page} from '../../../shared/models/page.interface';
import {HelpInfo} from '../../models/help-info.interface';
import {HelpInfoSearch} from '../../models/help-info-search.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {DialogsService} from '../../services/dialogs.service';
import {MessageService} from '../../../shared/services/message.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-chart-labels',
  templateUrl: './chart-labels.component.html',
  styleUrls: ['./chart-labels.component.scss']
})
export class ChartLabelsComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;
  code = this.router.getCurrentNavigation()?.extras?.state?.code;
  dialogs!: Page<HelpInfo>;
  private search!: HelpInfoSearch;
  private page: PageRequest = {page: 0, size: 100, sort: 'id', direction: 'asc'};

  constructor(private readonly dialogsService: DialogsService,
              private messageService: MessageService,
              private readonly router: Router) { }

  ngOnInit(): void {
    if (this.code) {
      this.dialogsService.getChartExplanations({code: this.code}, this.page).subscribe(
        data => this.dialogs = data
      );
    }
    else {
      this.dialogsService.getChartExplanations({}, this.page).subscribe(
        data => this.dialogs = data
      );
    }

    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }

  }

  loadChartLabels(event: PageRequest): void {
    this.page = event;
    if (this.search) {
      this.dialogsService.getChartExplanations(this.search, event).subscribe(
        data => this.dialogs = data
      );
    }
    else {
      this.dialogsService.getChartExplanations({}, event).subscribe(
        data => this.dialogs = data
      );
    }
  }

  searchDialogs(search: HelpInfoSearch): void {
    this.search = search;
    if (Object.keys(search).length === 0) {
      this.page = {page: 0, size: 100, sort: 'id' , direction: 'asc'};
    }
    this.dialogsService.getChartExplanations(search, this.page).subscribe(
      data => this.dialogs = data
    );
  }

}
